import {toEnglishDigit} from './persainDigitToEn'
import moment from 'jalali-moment'

export const formatPrice = (number) => {
  if (number && number?.toString().length > 3) {
    let arr2 = []
    let arr = number.toString().split('')

    let addedLength = 0

    if (arr.length % 3 !== 0) {
      arr.unshift('0')

      addedLength += 1

      if (arr.length % 3 !== 0) {
        arr.unshift('0')
        addedLength += 1
      }
    }

    arr.forEach((item, index) => {
      if (index !== 0 && index % 3 === 0 && index !== arr.length - 1) {
        arr2.push(',')
        arr2.push(item)
      } else {
        arr2.push(item)
      }
    })

    if (addedLength > 0) arr2.splice(0, addedLength)

    let str = ''
    arr2.forEach((item) => {
      str += item.toString()
    })

    return str
  } else {
    return number
  }
}

export const locationSearchStringToObject = (str) => {
  if (typeof str !== 'string') return undefined
  if (!str) return undefined
  if (!str?.trim()) return undefined
  /////
  let queryString = decodeURIComponent(str)
  if (queryString.startsWith('?')) queryString = queryString.replace('?', '')
  if (queryString.length === 0) return undefined
  /////
  const queryArray = queryString.split('&').map((pair) => pair.split('='))
  /////
  const queryObject = Object.fromEntries(queryArray)
  /////
  return queryObject
}

export const convertFullDateAndTime = (
  date,
  options = {second: true, minute: true, hour: true}
) => {
  if (date) {
    const coptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
    if (options.minute) {
      coptions.minute = '2-digit'
    }
    if (options.second) {
      coptions.second = '2-digit'
    }
    if (options.second) {
      coptions.hour = '2-digit'
    }
    let convertedDate = new Date(date).toLocaleDateString('fa-IR', coptions)

    const [weekday, day, month, year] = convertedDate.split(' ')
    return `${weekday} ${year} ${month.split(',')[0] || month} ${day}`
  } else {
    return ''
  }
}
export function convertDateString(inputDate) {
  // Parse the input date string using Date constructor
  const date = new Date(inputDate)

  // Get the year, month, and day components from the Date object
  const year = date.getFullYear()
  const month = date.getMonth() + 1 // Note: Months are zero-based, so we add 1
  const day = date.getDate()

  // Format the date components as a string in the desired format (YYYY/MM/DD)
  const formattedDate = `${year}/${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}`

  return formattedDate
}

export const objectToQueryString = (queryObject) => {
  if (typeof queryObject === 'object') {
    if (Object.keys(queryObject).length > 0) {
      let qs = '?'
      const qoEntries = Object.entries(queryObject)
      qoEntries.forEach(([key, value], index) => {
        qs += `${key}=${value}${index < qoEntries.length - 1 ? '&' : ''}`
      })
      //////
      return qs
    }
    return ''
  }
  return ''
}

export function convertToEnglishNumber(input) {
  const persianDigits = {
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
  }

  return input.replace(/[۰-۹]/g, (match) => persianDigits[match])
}

export function extractNumbersFromPersian(input) {
  return input.replace(/\d/g, '')
}

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result); // خروجی Base64
      } else {
        reject('Failed to convert file to Base64');
      }
    };

    reader.onerror = (error) => reject(error);
  });

export const convertValuNumberToPrice = (value) => {
  if (value) {
    const rawValue = value?.replace(/\D/g, '')
    return formatPrice(toEnglishDigit(rawValue))
  }
}
export const convertPersianTime = (time) => {
  if (time) {
    const result = moment(time).locale('fa').format('dddd DD MMMM jYYYY')
    return result
  } else {
    return '---'
  }
}
export function getBedroomLabel(bedroomNumber) {
  const bedroomLabels = ['تک خوابه', 'دو خوابه', 'سه خوابه', 'چهار خوابه']
  return bedroomLabels[parseInt(bedroomNumber, 10)] || ''
}

export const deleteAllCookies = () => {
  var cookies = document.cookie.split(';')

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i]
    var eqPos = cookie.indexOf('=')
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}

export const getSendFormatData = (date) => {
  return (
    moment(toEnglishDigit(date?.toString() ?? ''), 'jYYYY/jM/jD')
      .locale('en')
      .format('YYYY-MM-DDTHH:mm:ss.SSSSSSS') || ''
  )
}
export const convertToJalaali = (gregorianDate) => {
  // فرمت ورودی: MM/DD/YYYY
  const m = moment(gregorianDate, 'MM/DD/YYYY');
  if (!m.isValid()) return ''; // اگر تاریخ نامعتبر بود، رشته خالی برگردونه
  return m.format('YYYY/M/D'); // خروجی: 1404/4/23
};
export const bundleDateToISO = (date) => {
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return '';

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0'); // ماه‌ها از 0 شروع میشن
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
export const getSendFormatDataTwo = (date) => {
  return (
    moment(toEnglishDigit(date?.toString() ?? ''), 'jYYYY/jM/jD')
      .locale('en')
      .format('YYYY-MM-DD') || ''
  )
}

export const getPriceValue = (price) => {
  return price.replace(/,/g, '')
}

export const b64toBlob = async (b64Data) => {
  const blob = await fetch(b64Data).then((res) => res.blob())
  const file = new File([blob], Date.now() + 'image.png', {
    lastModified: new Date().getTime(),
    type: 'image/png',
  })
  return file
}

export const blobToBinary = async (blob) => {
  const buffer = await blob.arrayBuffer()

  const view = new Int8Array(buffer)

  return [...view].map((n) => n.toString(2)).join(' ')
}

export const checkRole = (userInfo, role) => {
  return userInfo?.userRoles?.find((a) => a.role.name?.includes(role))
}

export function numberToPersianWords(number) {
  const ones = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
  const tens = ["", "ده", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
  const hundreds = ["", "یکصد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];
  const bigNumbers = ["", "هزار", "میلیون", "میلیارد", "تریلیون"];

  if (number === 0) return "صفر ریال";

  let words = [];
  let numberStr = number.toString();
  let groups = [];

  while (numberStr.length > 0) {
      groups.unshift(numberStr.slice(-3));
      numberStr = numberStr.slice(0, -3);
  }

  groups.forEach((group, index) => {
      let num = parseInt(group);
      if (num === 0) return;

      let groupWords = [];

      let h = Math.floor(num / 100);
      let t = Math.floor((num % 100) / 10);
      let o = num % 10;

      if (h) groupWords.push(hundreds[h]);
      if (t === 1 && o > 0) {
          const teens = ["", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"];
          groupWords.push(teens[o]);
      } else {
          if (t) groupWords.push(tens[t]);
          if (o) groupWords.push(ones[o]);
      }

      if (bigNumbers[groups.length - 1 - index]) {
          groupWords.push(bigNumbers[groups.length - 1 - index]);
      }

      words.push(groupWords.join(" "));
  });

  return words.join(" و ") + " ریال";
}

export function getConvenienceTitle(item, allFakeDataSelectListType, ConvenienceFakeData) {
  if (item?.legalRequestTypeId) {
    try {
      if (!item?.legalRequestTypeId) {
        return ''
      }

      const statusType = allFakeDataSelectListType.find((a) => a.id === item.legalRequestTypeId)

      if (!statusType) {
        return ''
      }

      const convenienceData = ConvenienceFakeData.find((d) => d.id === statusType.status)

      return convenienceData?.title || ''
    } catch (error) {
      console.error('Error accessing convenience data:', error)
      return ''
    }
  } else {
    try {
      if (!item?.request?.legalRequestTypeId) {
        return ''
      }

      const statusType = allFakeDataSelectListType.find(
        (a) => a.id === item.request.legalRequestTypeId
      )

      if (!statusType) {
        return ''
      }

      const convenienceData = ConvenienceFakeData.find((d) => d.id === statusType.status)

      return convenienceData?.title || ''
    } catch (error) {
      console.error('Error accessing convenience data:', error)
      return ''
    }
  }
}
export const ConvenienceFakeData = [
  {
    title: 'خط اعتباری ',
    id: 1,
  },
  {
    title: ' منابع داخلی ',
    id: 2,
  },
  {
    title: 'ضمانت نامه',
    id: 3,
  },
  {
    title: 'کارگزاری',
    id: 4,
  },
  {
    title: 'سرمایه گذاری ',
    id: 5,
  },
  {
    title: 'بیشتر ',
    id: 6,
  },
]

export const fakeDataCreditLineList = [
  {
    id: 1002,
    title: 'نمونه سازی',
    size: 6,
    status: 1,
  },
  {
    id: 1003,
    title: 'تولید صنعتی',
    size: 6,
    status: 1,
  },
  {
    id: 1004,
    title: 'قبل از تولید صنعتی',
    size: 6,
    status: 1,
  },
  {
    id: 1005,
    title: 'سرمایه در گردش',
    size: 6,
    status: 1,
  },
  {
    id: 10020,
    title: 'لیزینگ و استصناع (خریدار)',
    size: 6,
    status: 1,
  },
  {
    id: 10021,
    title: 'لیزینگ و استصناع (فروشنده)',
    size: 6,
    status: 1,
  },
]
export const fakeDataConvenienceesList = [
  {
    id: 1007,
    title: 'نمونه سازی',
    size: 6,
    status: 2,
  },
  {
    id: 1008,
    title: 'فعالیت های صنعتی',
    size: 6,
    status: 2,
  },
  {
    id: 1009,
    title: 'سرمایه در گردش',
    size: 6,
    status: 2,
  },
  {
    id: 1011,
    title: 'خرید دین',
    size: 6,
    status: 2,
  },
]

export const fakeDataWarrantyList = [
  {
    id: 1012,
    title: 'مناقصه و مزایده',
    size: 6,
    status: 3,
  },
  {
    id: 1013,
    title: 'پیش پرداخت',
    size: 6,
    status: 3,
  },
  {
    id: 1014,
    title: 'تعهد پرداخت',
    size: 6,
    status: 3,
  },
  {
    id: 1015,
    title: 'حسن انجام کار',
    size: 6,
    status: 3,
  },
]

export const fakeDataBrokerageList = [
  {
    id: 1017,
    title: 'معاونت علمی فناوری',
    size: 6,
    status: 4,
  },
  {
    id: 1018,
    title: 'پارک علم و فناوری',
    size: 6,
    status: 4,
  },
  {
    id: 1019,
    title: 'تفاهم نامه',
    size: 12,
    status: 4,
  },
]

export const fakeDataInvestmentList = [
  {
    id: 1016,
    title: 'سرمایه گذاری خطر پذیر',
    size: 12,
    status: 5,
  },
]

export const allFakeDataSelectListType = [
  ...fakeDataCreditLineList,
  ...fakeDataConvenienceesList,
  ...fakeDataWarrantyList,
  ...fakeDataBrokerageList,
  ...fakeDataInvestmentList,
]

export function calculateProfileCompletion(profile) {
  if (!profile) {
    return 0
  }
  const {companyValidationFile, subjectOfActivity, webSite, otherDocumnet, ...data} = profile
  if (!data) {
    return 0
  }
  const totalFields = Object.keys(data).length
  const filledFields = Object.values(data).filter(
    (value) => value !== undefined && value !== null && value !== ''
  ).length

  const completionPercentage = (filledFields / totalFields) * 100
  return Math.round(completionPercentage)
}

export const companyTypeSelectedList = [
  {
    label: 'سهامی عام',
    value: '0',
  },
  {
    label: 'سهامی خاص',
    value: '1',
  },
  {
    label: 'مسئولیت محدود',
    value: '3',
  },
  {
    label: 'شرکت تعاونی',
    value: '4',
  },
]

export const getAddressPassvandName = (address) => {
  if (!address) {
    return null
  }
  if (String(address).split('.')[1] === 'pdf') {
    return '/media/svg/files/pdf.svg'
  } else if (String(address).split('.')[1] === 'docx') {
    return '/media/svg/files/doc.svg'
  } else if (
    String(address).split('.')[1] === 'png' ||
    String(address).split('.')[1] === 'jpeg' ||
    String(address).split('.')[1] === 'jpg'
  ) {
    return '/media/jpg.svg'
  } else if (String(address).split('.')[1] === 'pptx') {
    return '/media/svg/files/icons8-powerpoint.svg'
  } else if (String(address).split('.')[1] === 'rar') {
    return '/media/svg/files/rar.png'
  } else {
    return '/media/svg/files/doc.svg'
  }
}

export const geAllFakeDataLocationPlaceType = [
  {
    label: 'دفتر مرکزی',
    value: '0',
  },
  {
    label: 'کارگاه',
    value: '1',
  },
  {
    label: 'انبار',
    value: '2',
  },
  {
    label: 'شعبه',
    value: '3',
  },
]

export const geAllFakeDataBoardOfDirectorPositionList = [
  {
    label: "عضو هیات مدیره",
    value: "0",
  },
  {
    label: "مدیر عامل",
    value: "1",
  },
  {
    label: "رئیس",
    value: "2",
  },
  {
    label: "نائب رئیس",
    value: "3",
  },
  {
    label: "بازرس اصلي",
    value: "4",
  },
  {
    label: "بازرس علي البدل",
    value: "5",
  },
]

export function groupItemsByDate(items) {
  const groupedMap = new Map()

  items?.forEach((item) => {
    const date = moment(item.createdAt).locale('fa').format('dddd jDD jMMMM jYYYY')
    if (!groupedMap.has(date)) {
      groupedMap.set(date, [])
    }
    groupedMap.get(date).push(item)
  })

  return Array.from(groupedMap, ([date, items]) => ({date, items}))
}

export const handleCheckStatusZamenItem = (status) => {
  switch (status) {
    case 0:
      return 'بررسی اطلاعات'
    case 1:
      return 'تایید ضامن'
    case 2:
      return 'رد کردن ضامن'
    default:
      return 'تایین نشده است'
  }
}

export const getRequestStatusName = (status) => {
  switch (status) {
    case 0:
      return 'درحال بررسی'
    case 1:
      return 'عودت داده شده'
    case 2:
      return 'تایید شده'
    case 3:
      return 'دارای نقص'
    case 4:
      return 'بررسی و مذاکره'
    case 5:
      return 'طرح در کمیته تسهیلات'
    case 6:
      return 'طرح در کمیته سرمایه گذاری'
    case 7:
      return 'طرح در جلسه هیات مدیره'
    case 8:
      return 'مراجعه حضوری'
    case 9:
      return 'درانتظار تایید '
    default:
      return 'نامشخص'
  }
}

export const getFacilityTypeText = (type) => {
  const map = {
    10: 'قرض الحسنه',
    11: 'مشارکت مدنی',
    12: 'مشارکت حقوقی',
    13: 'سرمایه گذاری مستقیم',
    14: 'مضاربه',
    15: 'معاملات سلف',
    16: 'فروش اقساطی مواد اولیه، لوازم یدکی و ابزار کار',
    17: 'فروش اقساطی وسایل تولید ماشین‌آلات و تاسیسات',
    18: 'فروش اقساطی مسکن',
    19: 'اجاره به شرط تملیک',
    20: 'جعاله',
    21: 'مزارعه',
    22: 'مساقات',
    23: 'خرید دین',
    24: 'معاملات قدیم',
    25: 'استصناع',
    26: 'مرابحه',
  }

  return map[String(type)] || 'نوع نامشخص'
}

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}
